import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import PropTypes from 'prop-types'

import { Modal, ModalHeader, ModalSubHeader, ModalContent } from '@components/Modal'
import { Button } from '@components/Button'

export const ArchiveScenarioModal = ({ open, close, scenarioName, onUpdateScenario }) => {
  const [archiving, setArchiving] = useState(false)
  const archiveScenarioHandler = () => {
    onUpdateScenario({ plan_type: 'archived' })
    setArchiving(true)
  }

  return (
    <Modal open={open} onClose={close}>
      <ModalHeader>Archive your scenario</ModalHeader>
      <ModalSubHeader>It's kinda like stuffing papers into a drawer.</ModalSubHeader>
      <ModalContent>
        <p className='text-center'>Are you sure you would like to archive this scenario?</p>
        <p className='text-center'>{scenarioName}</p>
        <Box
          display='flex'
          justifyContent='center'
          className='flex justify-center gap-4'>
          <Button secondary disabled={archiving} onClick={close}>{archiving ? 'Archiving' : 'Go back'}</Button>
          <Button warning disabled={archiving} onClick={archiveScenarioHandler}>
            {archiving ? 'Archiving' : 'Archive'}
          </Button>
        </Box>

        <Box
          mt='1rem'
          display='flex'
          justifyContent='center'
          alignItems='center'
          flexDirection='column'>
          <small>Once you archive your scenario, you won't be able to access it again.</small>
          <small>We're working on a way to give you access to view archived scenarios.</small>
        </Box>
      </ModalContent>
    </Modal>
  )
}

ArchiveScenarioModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  scenarioName: PropTypes.string.isRequired,
  onUpdateScenario: PropTypes.func.isRequired
}
